import { Network } from "../types";

export const networks = {
  mainnet: {
    id: 1,
    type: "standard",
    name: "mainnet",
    address: "https://mainnet.phantom-rpc.com/rpc",
    description: "This is Casper main network.",
  } as Network,
  testnet: {
    id: 2,
    type: "standard",
    name: "testnet",
    address: "https://testnet.phantom-rpc.com/rpc",
    description: "This is Casper test network.",
  } as Network,
};
